import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import helperPlugin from 'utils/helperPlugin'
import './plugins/ant-design-vue'
import filters from './filters'
import './style/index.less'

Vue.use(helperPlugin)
Vue.config.productionTip = false
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
// event
window.eventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
